var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    {
      staticStyle: { padding: "40px 0 40px 0", "background-color": "#2D2D2D" }
    },
    [
      _c(
        "el-col",
        {
          staticStyle: {
            display: "flex",
            "justify-content": "center",
            "align-items": "center"
          },
          attrs: { span: 24 }
        },
        [
          _c("img", {
            staticStyle: {
              width: "100%",
              height: "132px",
              position: "absolute"
            },
            attrs: { loading: "lazy", src: require("../../assets/four.jpeg") }
          }),
          _vm._v(" "),
          _c(
            "span",
            { staticClass: "search-text", staticStyle: { "z-index": "11" } },
            [_vm._v('"Enfield"')]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b63d1866", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b63d1866","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/search/searchingImageSection.vue
// module id = null
// module chunks = 